import { useQuery, useQueryClient } from "@tanstack/react-query";
import { api, type SessionInfo } from "../api";

export const SESSION_KEY = ["session"] as const;

/** The session, or null when nobody is signed in (the endpoint answers null rather than 401). */
const sessionQuery = { queryKey: SESSION_KEY, queryFn: () => api<SessionInfo | null>("/auth/session"), staleTime: 60_000 };

export function useSession() {
  return useQuery(sessionQuery);
}

/** Whether the signed-in role has a permission (the server checks again on every request). */
export function useCan(permission: string): boolean {
  const { data } = useSession();
  return Boolean(data?.permissions.includes(permission));
}

/** The first page after sign-in: Team estimates for a person who answers surveys and can't see costs, else Programs (TC-AUTH-026). */
export function landingFor(s: SessionInfo | null | undefined): string {
  const p = s?.permissions ?? [];
  return !p.includes("costs.view") && p.includes("surveys.answer") ? "/estimate" : "/programs";
}

/** Reloads the session (after signing in) before the caller moves on. */
export function useRefreshSession() {
  const qc = useQueryClient();
  return () => qc.fetchQuery({ ...sessionQuery, staleTime: 0 });
}
